/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core'
import '../lib/wave/wave.css'

function Background() {
    return (
        <div css={css`
            height: 50em;
        `}>
            <div className="waveWrapper waveAnimation">
                <div className="waveWrapperInner bgTop">
                    <div css={css`
                        background-image: url('./wave/wave-top.png')
                    `}
                        className="wave waveTop"
                    >
                    </div>
                </div>
                <div className="waveWrapperInner bgMiddle">
                    <div css={css`
                        background-image: url('./wave/wave-mid.png') 
                    `} className="wave waveMiddle"
                    >
                    </div>
                </div>
                <div className="waveWrapperInner bgBottom">
                    <div css={css`
                        background-image: url('./wave/wave-bot.png');
                    `} className="wave waveBottom"
                    >
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function Header(props) {
    const app = props.app

    const Navigation = () => (
        <div css={css`
            display: flex;
            align-items: center;
            z-index: 2;
            a {
                text-decoration: none;
                margin-left: 10px;
                font-size: 18px;
                font-weight: 600;
                padding: 8px 8px;
            }

            a:hover {
                border-radius: 8px;
                background-color: rgba(50, 50, 50, 0.1);
                color: #3F3F3F;
            }
        `}>
            <a
                href='https://onmyway133.com'
            >
                Home
            </a>
            <a
                href='https://onmyway133.com/writing'
            >
                Blog
            </a>
            <a
                href='https://onmyway133.com/about'
            >
                About
            </a>
        </div>
    )

    const Logo = () => (
        <a css={css`
            text-decoration: none;
            color: #1c1c1c;
            z-index: 2;
        `} 
            href="https://onmyway133.com">
            <div css={css`
                display: flex;
                justify-content: center;
                align-items: center;
            `}>

                <img css={css`
                    width: 50px;
                    height: auto;
                    border-radius: 6px;
                `}
                    src={require(`../images/onmyway133.jpeg`)}
                />
                <span css={css`
                    font-size: 1.4em;
                    margin-left: 10px;
                    font-weight: bold;
                    user-select: none;
                `}>
                    onmyway133
                </span>
            </div>
        </a>
    )

    return (
        <div css={css`
            position: relative;
        `}>
            <Background />
            <div css={css`
                position: absolute;
                top: 2vh;
                left: 0;
                width: 100%;
                height: 50%;
            `}>
                <div css={css`
                    display: flex;
                    justify-content: space-around;
                    flex-direction: row;
                    align-items: center;
                    flex-wrap: wrap;
                `}>
                    <Logo />
                    <Navigation />
                </div>
            </div>
        </div>
    )
}